import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=37c6e731&scoped=true&"
import script from "./Disclaimers.vue?vue&type=script&lang=js&"
export * from "./Disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./Disclaimers.vue?vue&type=style&index=0&id=37c6e731&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6e731",
  null
  
)

export default component.exports